// src/components/common/SkipToDashboardButton.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const ArrowRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    className="w-4 h-4"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
    />
  </svg>
);

const SkipToDashboardButton = ({ onSkip, disabled, className }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onSkip) {
      onSkip();
    } else {
      navigate("/dashboard");
    }
  };

  if (!onSkip && !navigate) return null;

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={`
        flex items-center justify-center 
        px-4 py-2 md:py-2.5
        text-sm font-medium text-slate-700 bg-white 
        border border-slate-300 rounded-md shadow-sm 
        hover:bg-slate-50 hover:border-slate-400 hover:text-slate-800
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
        disabled:opacity-50 disabled:cursor-not-allowed 
        transition-colors duration-150 ease-in-out
        ${className || ""} 
      `}
    >
      <span className="mr-2">
        <ArrowRightIcon />
      </span>
      <span>Go to Dashboard</span>
    </button>
  );
};
export default SkipToDashboardButton;
